// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"749d292a","377":"1509ad15","417":"59ba0ff8","467":"ffe7aa46","626":"e5e40771","870":"884ab8bd"}[chunkId] + ".js";
};